export default {
  methods: {
    loadDefaultGeometries({ componentObj, componentName }) {
      const promises = [];
      if (componentObj && componentObj.geometry_updates && componentObj.geometry_updates.length > 0) {
        componentObj.geometry_updates.forEach(geometryUpdate => {
          promises.push(
            this.swapGeometries({ geometryUpdate, updateType: "model_default" })
          );
        })
      }
      return new Promise(resolve => {
        return Promise.all(promises).then(() => {
          this.saveTexturePromise(componentObj, componentName).then(resolve);
        });
      });
    }
  },
};